import { createFileRoute } from "@tanstack/react-router";
import { seoHead } from "@/lib/seo/head";
import OrganizationLanding from "@/pages/OrganizationLanding";

export const Route = createFileRoute("/lp/organizations")({
  head: () => {
    const head = seoHead("/lp/organizations");
    const title = "Organization Partnerships | Home Approach";
    const description = "Help your employees, members, or community get closer to homeownership. Explore per-member partnerships and select pilot programs with Home Approach.";
    return {
      ...head,
      meta: head.meta
        .filter((tag) => tag.property !== "og:image" && tag.name !== "twitter:image")
        .map((tag) => {
          if ("title" in tag) return { title };
          if (tag.name === "description" || tag.property === "og:description" || tag.name === "twitter:description") return { ...tag, content: description };
          if (tag.property === "og:title" || tag.name === "twitter:title") return { ...tag, content: title };
          if (tag.property === "og:type") return { ...tag, content: "website" };
          return tag;
        }),
    };
  },
  component: OrganizationLanding,
});
